export default __webpack_public_path__ + "static/media/ISKO CLASS 6 SYLLABUS.fe5f7222.pdf";